import { Component } from '@angular/core'

@Component({
  template: '<ftr-supported-browsers></ftr-supported-browsers>',
})
export class SupportedBrowsersPage {}
